import EventEmitter from 'eventemitter3';

export interface ILoaderService {
    showLoader(): void;
    hideLoader(): void;
    getLoading(): boolean;
    eventEmitter(): EventEmitter;
}

export const loaderEvent = 'LOADER_EVENT';

export default class LoaderService implements ILoaderService {
    static serviceInstance: ILoaderService;
    private readonly emitter: EventEmitter;
    private loading = false;

    static getInstance(): ILoaderService {

        if (!this.serviceInstance) {
            this.serviceInstance = new LoaderService();
        }

        return this.serviceInstance;
    }

    constructor() {
        this.emitter = new EventEmitter();
    }

    showLoader(): void {
        this.loading = true;
        this.broadcast();
    }

    hideLoader(): void {
        this.loading = false;
        this.broadcast();
    }

    getLoading(): boolean {
        return this.loading;
    }

    eventEmitter(): EventEmitter {
        return this.emitter;
    }

    private broadcast() {
        this.emitter.emit(loaderEvent, this.loading);
    }
}



// WEBPACK FOOTER //
// ./src/services/LoaderService.ts